import { toISOString } from "@/shared/lib/date-time-performance";
import type { EventFormValues } from "../ui/EventForm";

export function serializeEventForm(values: EventFormValues) {
  return {
    title: values.title,
    status: values.status,
    categoryId: values.categoryId,
    eventFeatures: values.eventFeatures,
    eventDate: toISOString(new Date(values.eventDate)),
    endDate: values.endDate ? toISOString(new Date(values.endDate)) : null,
    roomId: null,
    locationText: values.locationText || null,
    locationProvince: values.locationProvince?.trim() || null,
    isProvincial: values.isProvincial ?? false,
    perDiemPolicyId: values.perDiemPolicyId ?? null,
    perDiemDays: values.isProvincial ? (values.perDiemDays ?? 1) : null,
    notes: values.notes || null,
  };
}
